import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BasetaoSpreadsheetGuide from "../pages/article/basetao-spreadsheet-guide/page";
import BasetaoReview2026 from "../pages/article/basetao-review-2026/page";
import BasetaoShippingCostGuide from "../pages/article/basetao-shipping-cost-guide/page";
import BasetaoCouponCodes from "../pages/article/basetao-coupon-codes/page";
import BasetaoWarehouseGuide from "../pages/article/basetao-warehouse-guide/page";
import IsBasetaoLegitPage from "../pages/article/is-basetao-legit/page";
import BasetaoSpreadsheetTemplatePage from "../pages/article/basetao-spreadsheet-template/page";
import BasetaoSpreadsheetFindsPage from "../pages/article/basetao-spreadsheet-finds/page";
import BasetaoVsAlternativesPage from "../pages/article/basetao-vs-alternatives/page";
import BasetaoShoppingGuidePage from "../pages/article/basetao-shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/basetao-spreadsheet-guide",
    element: <BasetaoSpreadsheetGuide />,
  },
  {
    path: "/article/basetao-review-2026",
    element: <BasetaoReview2026 />,
  },
  {
    path: "/article/basetao-shipping-cost-guide",
    element: <BasetaoShippingCostGuide />,
  },
  {
    path: "/article/basetao-coupon-codes",
    element: <BasetaoCouponCodes />,
  },
  {
    path: "/article/basetao-warehouse-guide",
    element: <BasetaoWarehouseGuide />,
  },
  {
    path: "/article/is-basetao-legit",
    element: <IsBasetaoLegitPage />,
  },
  {
    path: "/article/basetao-spreadsheet-template",
    element: <BasetaoSpreadsheetTemplatePage />,
  },
  {
    path: "/article/basetao-spreadsheet-finds",
    element: <BasetaoSpreadsheetFindsPage />,
  },
  {
    path: "/article/basetao-vs-alternatives",
    element: <BasetaoVsAlternativesPage />,
  },
  {
    path: "/article/basetao-shopping-guide",
    element: <BasetaoShoppingGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;